<ul class="notifier__container-list">
  <li class="notifier__container-list-item" *ngFor="let notification of notifications; trackBy: identifyNotification">
    <notifier-notification [notification]="notification" (ready)="onNotificationReady($event)" (dismiss)="onNotificationDismiss($event)">
    </notifier-notification>
  </li>
</ul>
